import CollaborationService from './CollaborationService'
import CollaborationAnnotEvent from './CollaborationAnnotEvent'
import CollaborationMqttService from './CollaborationMqttService'
import CollaborationAwsSqsService from './CollaborationAwsSqsService'

// const awsSnsService = new AwsSnsService()
const collaborationService =  new CollaborationService()
const collaborationAnnotEvent = new CollaborationAnnotEvent()
const collaborationMqttService = new CollaborationMqttService()
const collaborationAwsSqsService = new CollaborationAwsSqsService()

export {
  collaborationService,
  collaborationAnnotEvent,
  collaborationMqttService,
  collaborationAwsSqsService
}